import React from 'react';

import { useNavigate } from 'react-router-dom';

import { message } from 'antd';

import { useSelector, useDispatch } from 'react-redux';
import Messages from 'i18n/messages/home';
import { dialogFunction } from 'common/components/index';

import { DeleteOutlined } from '@ant-design/icons';

import ButtonSmallIcon from 'common/components/button/ButtonSmallIcon';
import gridSelector from 'common/components/grid-view/controllers/selectors';
import * as actionsGrid from 'common/components/grid-view/controllers/actions';

import * as actions from 'pages/branded-assets/controllers/actions';
import * as brandingActions from '@redux/branding/actions';
import { ProductIxoneCertification } from './ProductIxoneCertification';

import * as assetFullViewSelector from 'pages/asset-full-view/controllers/selectors';
import { useDispatchReloadPage } from 'hooks/useReloadPage';

import { useCheckAllowDeleteAssets, useQueryBrandingNavigation } from 'hooks';
import useCheckFavoriteRoute from 'hooks/useCheckFavoriteRoute';
import useUpdateIXONEShield from 'common/components/product-add/useUpdateIXONEShield';
import useCloseDetail from 'hooks/useCloseDetail';
import { useCheckShowIxOneWarning } from 'common/components/product-add/useCheckShowIxOneWarning';

import * as services from 'services/assetProduct';
import {
  IXONECertificationWrapper,
  TYPE_VIEW,
} from 'common/components/product-add/IXONECertificationWrapper';

const DeleteAssets = ({ isEditting, disabled }) => {
  const dispatch = useDispatch();
  const selectedIds = useSelector(gridSelector.makeSelectItemsSelection());

  const selectedItemList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const assetFullView = useSelector(
    assetFullViewSelector.makeSelectAssetData()
  );

  const { checkAllowDeleteAssetFull, checkAllowDeleteAssetGrid } =
    useCheckAllowDeleteAssets();

  const { handleUpdateIXONEShield } = useUpdateIXONEShield();
  const { showConfirmIxOneModal } = useCheckShowIxOneWarning();

  const { goBack } = useCloseDetail();

  const { invalidateBrandingNavigation } = useQueryBrandingNavigation();

  const isAllowDeleteGrid = checkAllowDeleteAssetGrid();
  const isAllowDeleteFull = checkAllowDeleteAssetFull();

  const isFullView = !!assetFullView?.id;

  const isAllowDelete = allowDeleteAssets(
    isFullView,
    isAllowDeleteGrid,
    isAllowDeleteFull
  );

  const reloadPage = useDispatchReloadPage();

  const isFavoriteRoute = useCheckFavoriteRoute();

  const handleDelete = async (ixoneIgnore, fieldList) => {
    // params of idAsset is array
    const listAssets = isFullView ? [assetFullView.id] : selectedIds;
    try {
      const response = await services.deleteAssets({
        listAssets,
      });

      const productIxOneIds = fieldList?.map((item) => item?.productId) ?? [];

      if (response.isSuccess) {
        await handleUpdateIXONEShield(ixoneIgnore, productIxOneIds);
        if (isFullView) {
          goBack();
        }

        message.success('Delete successfully');
        dispatch(actionsGrid.deleteItemsSelection());
        dispatch(actions.resetDeleteAssets());
        if (isFavoriteRoute) {
          invalidateBrandingNavigation();
        }
        reloadPage();
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error(error);
    }
  };

  const checkFromTDCImageExisted = () => {
    return isFullView
      ? assetFullView?.fromTdcImage
      : selectedItemList?.some((item) => item?.fromTdcImage);
  };

  const onclick = (handleConfirmIXONE) => {
    const isExistFromTDCImage = checkFromTDCImageExisted();
    const selectedAssetIds = isFullView ? [assetFullView.id] : selectedIds;

    showConfirmIxOneModal({
      showModal: isExistFromTDCImage,
      handleConfirmIXONE,
      assetIds: selectedAssetIds,
    });
  };

  const confirmDelete = (ixoneIgnore, fieldList) => {
    dialogFunction({
      type: 'warn',
      content: 'Are you sure you want to delete asset?',
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: () => handleDelete(ixoneIgnore, fieldList),
    });
  };

  return (
    <IXONECertificationWrapper
      type={TYPE_VIEW.IMAGE_ASSET}
      onConfirm={(ixoneIgnore, fieldList) => {
        confirmDelete(ixoneIgnore, fieldList);
      }}
      Component={ProductIxoneCertification}
    >
      {(handleConfirmIXONE) => (
        <ButtonSmallIcon
          className='button-item-dropdown'
          icon={<DeleteOutlined />}
          label={Messages.deleteAssets}
          onClick={() => onclick(handleConfirmIXONE)}
          disabled={!isAllowDelete || isEditting || disabled}
        />
      )}
    </IXONECertificationWrapper>
  );
};

const allowDeleteAssets = (
  isFullView,
  isAllowDeleteGrid,
  isAllowDeleteFull
) => {
  if (isFullView) {
    return isAllowDeleteFull;
  }

  return isAllowDeleteGrid;
};

export default DeleteAssets;
